export default "__VITE_ASSET__35645970__"